import React, { useContext } from 'react';
import styles from './Styles';
import { AppContext } from 'App.context';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { show2FAModal } from 'Components/common/TwoFactorModal/TwoFactorModal';

export default function DeleteCustomerModal({ actions, state }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  return (
    <div>
      <div style={styles.textContainerModal}>
        <div style={styles.iconModalDelete}>
          <ExclamationCircleOutlined />
        </div>
        <div style={styles.titleModal}>
          <strong>{translate('customers.customersDetail.deleteCustomer.deleteTitle')}</strong>
        </div>
        <div style={styles.textModal}>
          <p>{translate('customers.customersDetail.deleteCustomer.deleteDescription')}</p>
        </div>
      </div>
      <div style={styles.modalButton}>
        <Button
          key="delete"
          type="primary"
          danger
          onClick={async () => {
            const twoFAResult = await show2FAModal();

            if (twoFAResult === true) {
              actions.delete(state.userToDelete);
            }
          }}
          style={styles.deleteButton}
        >
          {translate('customers.customersDetail.deleteCustomer.deleteButton')}
        </Button>
      </div>
      <div style={styles.modalButton}>
        <Button key="cancel" onClick={actions.closeDeleteUserModal} style={styles.cancelButton}>
          {translate('customers.customersDetail.deleteCustomer.cancelButton')}
        </Button>
      </div>
    </div>
  );
}
